import {
  AfterViewInit, Component, ElementRef, EventEmitter, HostListener, OnInit, Output,
  ViewChild
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {AchooFilterBoxComponent} from '../../../../core/achoo-filter-box/achoo-filter-box.component';
import {ReferenceDataService} from '../../../../services/reference-data/reference-data.service';

@Component({
  selector: 'dismiss-influencer-popup',
  templateUrl: './dismiss-influencer-popup.component.html',
  styleUrls: ['./dismiss-influencer-popup.component.scss']
})
export class DismissInfluencerPopupComponent implements OnInit {
  @ViewChild('dismissReason') dismissReason: AchooFilterBoxComponent;
  @Output() dismissInfluencer: EventEmitter<any> = new EventEmitter();
  @Output() closeDismiss: EventEmitter<any> = new EventEmitter();
  dismissForm: FormGroup;
  canSubmit = false;
  dismissReasons = [];
  selectedDismissReason;
  constructor(private translate: TranslateService, private referenceData: ReferenceDataService) { }

  ngOnInit() {
    this.dismissForm = new FormGroup({
      dismissReason: new FormControl()
    });
    this.loadDismissReason();
  }

  private loadDismissReason() {
    this.referenceData.loadDismissReasons().subscribe((res) => {
      this.dismissReasons = res;
    });
  }

  closePopup() {
    this.closeDismiss.emit();
  }

  onDismiss() {
    if (!this.canSubmit || !this.selectedDismissReason) {
      return;
    }
    this.dismissInfluencer.emit({
      reason: this.selectedDismissReason
    });
  }

  onKeyDown(evt) {
    if (evt.keyCode === 13) {
      this.onDismiss();
    }
  }

  onSelectReason() {
    setTimeout(() => {
      if (this.selectedDismissReason) {
        this.canSubmit = true;
      }
    }, 500);
  }

}



// WEBPACK FOOTER //
// ./src/app/main/admin/influencer-review/dismiss-influencer-popup/dismiss-influencer-popup.component.ts